export default function Anchor({ anchor }) {
    return <a name={anchor} id={'anchor-' + anchor}></a>;
}
